import Service from "../../services";
import { checkAndReturn, reLogin } from "../../main";

const state = {
  User: {
    user_type: "USP",
  },
  login: {
    lastCredentials: [],
  },
};

const getters = {};

const actions = {
  getUser({ commit }) {
    return Service.Auth.getUser().then((res) => {
      if (res.status === 200) {
        commit("setUserInfo", res.data);
      }
      if (res.status === 401) {
        reLogin(res.data.message);
      }
      return res.data;
    });
  },

  getMasterRegister({ commit }, params) {
    return Service.Auth.getMasterRegister().then((res) => {
      return checkAndReturn(params, res);
    });
  },
  register({ commit }, data) {
    return Service.Auth.register(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  login({ commit }, data) {
    return Service.Auth.login(data).then((res) => {
      return checkAndReturn(data, res);
    });
  },
  logout({ commit }, data) {
    return Service.Auth.logout(data).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  getUsers({ commit }, params) {
    return Service.Auth.getUsers(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  show({ commit }, params) {
    return Service.Auth.show(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  create({ commit }, params) {
    return Service.Auth.create(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  store({ commit }, data) {
    return Service.Auth.store(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  edit({ commit }, data) {
    return Service.Auth.edit(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  update({ commit }, data) {
    return Service.Auth.update(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  delete({ commit }, data) {
    return Service.Auth.delete(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  getLogActivities({ commit }, data) {
    return Service.Auth.getLogActivities(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  forgotPassword({ commit }, data) {
    return Service.Auth.forgotPassword(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  resetPassword({ commit }, data) {
    return Service.Auth.resetPassword(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },
};

const mutations = {
  // for local test
  setRole(state) {
    switch (state.User.user_type) {
      case "USP":
        state.User.user_type = "RSP";
        break;

      case "RSP":
        state.User.user_type = "สป.อว.";
        break;

      case "สป.อว.":
        state.User.user_type = "ผู้เชี่ยวชาญ";
        break;

      case "ผู้เชี่ยวชาญ":
        state.User.user_type = "USP";
        break;
    }
  },

  setUserInfo(state, value) {
    state.User = value;
  },

  clearUserInfo(state) {
    state.User = {
      user_type: "USP",
    };
  },

  rememberMe(state, value) {
    state.login.lastCredentials = value;
  },

  clearCredentials(state) {
    state.login.lastCredentials = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
